export const getPDPUrl = (url_key: string, params?: string): string => {
    return `/p/${url_key}${params && params != '' ? `?${params}` : ''}`
}
